module.exports = __webpack_public_path__ + "img/icon-chevron-right.50ba6883.svg";